/*
 * Decléor — Open the cart drawer on ARRIVAL from a flagged link.
 * ---------------------------------------------------------------------------
 * Built for external add-to-cart links — e.g. the skin-diagnostic sends the customer to:
 *     /cart/add?items[0][id]=…&return_to=/cart/update?updates[…]=1&attributes[source]=diagnostic-peau&…&return_to=/?open_cart=1
 * (the former /cart/{id}:{qty} permalink replaced the cart; this chain adds to it).
 * Shopify adds the recommended products + cart attributes server-side, redirects to the storefront
 * (return_to), and this slides the cart drawer open over it — instead of dropping them on the bare
 * /cart page. It dispatches the theme's own `theme:drawer:open` on #drawer-cart (the event the header
 * cart icon fires); the theme's CartItems controller then fetches /cart.js and renders the populated cart.
 *
 * TWO triggers, because Shopify often STRIPS the query string from return_to (so ?open_cart=1 may not
 * survive the redirect):
 *   1) URL flag  ?open_cart=1  — primary. One-shot: stripped from the URL so reload/back won't reopen.
 *   2) Cart attribute  source == "diagnostic-peau"  — fallback. Set by attributes[source]=… in the
 *      permalink (survives the redirect regardless of the query). Injected by Liquid as data-cart-source
 *      (no extra fetch). One-shot per session, and never on the /cart or /checkout pages.
 *
 * No-op without a trigger or a drawer-style cart. A few spaced attempts cover slow theme init.
 */
(function () {
  'use strict';

  var tag = document.currentScript || document.querySelector('script[data-cart-open-on-arrival]');
  var PARAM = (tag && tag.getAttribute('data-open-param')) || 'open_cart';
  var ATTR_VAL = (tag && tag.getAttribute('data-open-attr-value')) || 'diagnostic-peau';
  var CART_SOURCE = (tag && tag.getAttribute('data-cart-source')) || '';

  function drawer() {
    return document.getElementById('drawer-cart') || document.querySelector('[data-drawer="drawer-cart"]');
  }
  function isOpen(d) {
    return !!d && (d.classList.contains('drawer--visible') || d.classList.contains('is-open'));
  }
  function open() {
    var d = drawer();
    if (!d || isOpen(d)) { return; }
    d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
  }
  // A few spaced attempts: the first that lands after the theme binds its drawer controller opens it;
  // later ones no-op (isOpen() is then true). Covers fast and slow theme initialisation.
  function schedule() { [400, 900, 1600, 2600].forEach(function (ms) { setTimeout(open, ms); }); }
  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  // 1) Primary — explicit URL flag. Strip it so a reload / back-button doesn't re-trigger.
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
  if (params && params.get(PARAM)) {
    try {
      params.delete(PARAM);
      var qs = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) { /* non-fatal */ }
    onReady(schedule);
    return;
  }

  // 2) Fallback — the diagnostic cart attribute (survives even if return_to dropped the query). Open once
  //    per session; skip the cart/checkout pages where a drawer would be redundant.
  if (CART_SOURCE && CART_SOURCE === ATTR_VAL) {
    var path = window.location.pathname || '';
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) { return; }
    var KEY = 'decleor_cart_arrival_opened';
    try {
      if (sessionStorage.getItem(KEY)) { return; }
      sessionStorage.setItem(KEY, '1');
    } catch (e) { /* private mode etc. — still open, just not guarded */ }
    onReady(schedule);
  }
})();
